<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-neutral-900 dark:to-neutral-800 relative overflow-hidden">
    <!-- Dekoratif Elementler -->
    <div class="absolute inset-0">
      <!-- Grid Pattern -->
      <div class="absolute inset-0 bg-[url('/assets/images/grid-pattern.svg')] opacity-[0.03]"></div>
      
      <!-- Dekoratif Çizgiler -->
      <div class="absolute left-0 right-0 top-20 h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent"></div>
      <div class="absolute left-0 right-0 bottom-20 h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent"></div>
      
      <!-- Blur Efektleri -->
      <div class="absolute -top-40 -right-40 w-[600px] h-[600px] bg-primary/5 rounded-full filter blur-3xl"></div>
      <div class="absolute -bottom-40 -left-40 w-[600px] h-[600px] bg-secondary/5 rounded-full filter blur-3xl"></div>
    </div>

    <div class="relative z-10">
      <!-- Logo ve İçerik Container -->
      <div class="bg-white/70 dark:bg-neutral-800/70 backdrop-blur-xl rounded-2xl border border-gray-200/50 dark:border-neutral-700/50 p-8 md:p-12 w-[90vw] max-w-lg mx-auto">
        <!-- Logo -->
        <div class="mb-10 flex justify-center">
          <NuxtLink to="/" class="inline-block">
            <img 
              v-if="$colorMode.value === 'dark'"
              src="/assets/images/tp-logo-dark.png" 
              alt="Teknopark Logo" 
              class="h-6 md:h-8"
            />
            <img 
              v-else
              src="/assets/images/tp-logo.png" 
              alt="Teknopark Logo" 
              class="h-6 md:h-8"
            />
          </NuxtLink>
        </div>

        <!-- 404 Başlık -->
        <div class="text-center mb-8">
          <div class="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-primary/10 dark:bg-primary/20 mb-6">
            <svg class="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          </div>
          <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-3">
            {{ error?.statusCode === 404 ? 'Sayfa Bulunamadı' : 'Bir Hata Oluştu' }}
          </h1>
          <div class="text-sm font-medium text-primary mb-6">
            Hata Kodu: {{ error?.statusCode || '404' }}
          </div>
          <p class="text-gray-600 dark:text-gray-400 text-base">
            {{ error?.message || 'Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir.' }}
          </p>
        </div>

        <!-- Butonlar -->
        <div class="flex flex-col sm:flex-row gap-3">
          <NuxtLink 
            to="/"
            class="flex-1 inline-flex items-center justify-center px-6 py-3.5 bg-primary text-white rounded-xl transition-all duration-200 hover:bg-primary/90 group"
          >
            <svg class="w-5 h-5 mr-2 transition-transform duration-200 group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
            </svg>
            Ana Sayfaya Dön
          </NuxtLink>
          
          <button 
            @click="router.back()"
            class="flex-1 inline-flex items-center justify-center px-6 py-3.5 bg-gray-100 dark:bg-neutral-700 text-gray-900 dark:text-white rounded-xl transition-all duration-200 hover:bg-gray-200 dark:hover:bg-neutral-600 group"
          >
            <svg class="w-5 h-5 mr-2 transition-transform duration-200 group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 17l-5-5m0 0l5-5m-5 5h12"/>
            </svg>
            Geri Git
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const props = defineProps({
  error: Object
})

const router = useRouter()
</script>

<style scoped>
.group:hover svg {
  transform: translateX(-4px);
}
</style> 